
import React from 'react';
import { Tabs } from 'antd';
import { useTypedSelector } from "../store";
import { Navigate } from "react-router-dom";
import AddEmployee from './AddEmployee';
import ListEmployee from './ListEmployee';

const { TabPane } = Tabs;
const Employee: React.FC =()=> {
    const { authData, isLogin } = useTypedSelector((state) => {
        return {
          authData: state.Auth.loginData,
          isLogin: state.Auth.isLogin,
        };
    });
    console.log(authData, isLogin);
      
    if(!isLogin){
        return <Navigate to="/login" replace/>
    }

    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Employees" key="1">
                <ListEmployee />
            </TabPane>
            <TabPane tab="Add Employee" key="2">
                <AddEmployee />
            </TabPane>
        </Tabs>
    )

};

export default Employee;